import { PaperClipOutlined, UploadOutlined } from "@ant-design/icons";
import CloseCircleTwoTone from "@ant-design/icons/lib/icons/CloseCircleTwoTone";
import EditTwoTone from "@ant-design/icons/lib/icons/EditTwoTone";
import EyeTwoTone from "@ant-design/icons/lib/icons/EyeTwoTone";
import SaveTwoTone from "@ant-design/icons/lib/icons/SaveTwoTone";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  List,
  Modal,
  Popover,
  Row,
  Select,
  Spin,
  Tabs,
  Upload,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  ListAction,
  listLoaiyeucauAll,
  listLichsuthaydoi,
  ticketDetailURL,
  ticketUpdateDueDateURL,
  ticketUpdateFormData,
} from "../constants";
import { localhost } from "../server_url";
import { getUser } from "../store/actions/user";
import { cloneTicket, ticketData } from "../store/reducers/ticketData";
import { authAxios } from "../utils";
import { Upload_Ticket_File, Upload_Ticket_File_Modal } from "./Api";
import { AsyncMention, ListComment } from "./Component";
import EditableTable from "./component/EditableTable";
import {
  assignAddTicketAPI,
  assignChangeTicketAPI,
  assignDeleteTicketAPI,
  deleteTicketAPI,
  doneTicketAPI,
  forwardTicketAPI,
  openNotificationWithIcon,
  reprocessTicketAPI,
  showConfirmAccept,
  showConfirmClose,
  showConfirmProcess,
} from "./Function";
import PDFViewer from "./ViewPDF";

const cookies = new Cookies();

const timeout = (delay) => {
  return new Promise((res) => setTimeout(res, delay));
};

const { TabPane } = Tabs;

const layout = {
  labelCol: { span: 22, offset: 1 },
  wrapperCol: { span: 22, offset: 1 },
};
const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
const DateFormat = "YYYY-MM-DD";
const customFormat = (value) => `${value.format(DateFormat)}`;
function disabledDate(current, date) {
  // Can not select days before today and today
  return current && current < moment(date).endOf("day");
}

const useResetFormOnCloseModal = ({ form, visible }) => {
  const prevVisibleRef = useRef();
  useEffect(() => {
    prevVisibleRef.current = visible;
  }, [visible]);
  const prevVisible = prevVisibleRef.current;
  useEffect(() => {
    if (!visible && prevVisible) {
      form.resetFields();
    }
  }, [visible]);
};
const ModalDinhKemFileKhac = ({
  visible,
  onCancel,
  ticketid,
  fetchTicketDetail,
}) => {
  const [form] = Form.useForm();
  const [selectedFileUploadList, setselectedFileUploadList] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false);
  useResetFormOnCloseModal({
    form,
    visible,
  });
  const onFinish = (values) => {
    if (values.filedinhkemkhac) {
      Upload_Ticket_File_Modal(
        ticketid,
        values.filedinhkemkhac.file.originFileObj,
      )
        .then((res) => {
          // console.log("dinh kem file ok")
          setLoadingUpload(false);
          onCancel();
          fetchTicketDetail();
        })
        .catch((err) => {
          console.log("sai");
        });
    }
  };
  const onFinishFailed = () => {
    setLoadingUpload(false);
  };
  const onOk = () => {
    setLoadingUpload(true);
    form.submit();
  };
  const onCancelModal = () => {
    setselectedFileUploadList([]);
    form.setFieldsValue({
      filedinhkemkhac: null,
    });
    onCancel();
  };

  const uploadFileRequest = ({ file, onSuccess, name }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const handleChange = (info) => {
    let selectedFileList = [...info.fileList];
    setselectedFileUploadList(selectedFileList);
    // console.log(selectedFileList)
    if (selectedFileList.length === 0) {
      form.setFieldsValue({
        filedinhkemkhac: null,
      });
    }
  };
  return (
    <Modal
      title="Đính kèm file"
      visible={visible}
      onOk={onOk}
      onCancel={onCancelModal}
      confirmLoading={loadingUpload}
    >
      <Form
        form={form}
        layout="vertical"
        name="userForm"
        validateMessages={validateMessages}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="filedinhkemkhac"
          label="Đính kèm file"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Upload.Dragger
            fileList={selectedFileUploadList}
            onChange={handleChange}
            customRequest={uploadFileRequest}
            multiple
          >
            <Button icon={<UploadOutlined />} htmlType="button">
              Nhấn để chọn file
            </Button>
          </Upload.Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
};
const ModalFormDelete = ({
  visible,
  onCancel,
  ticketid,
  stateTo,
  fetchTicketDetail,
}) => {
  const [form] = Form.useForm();
  const [selectedFileUploadList, setselectedFileUploadList] = useState([]);
  const [loadingDelete, setLoadingDelete] = useState(false);
  useResetFormOnCloseModal({
    form,
    visible,
  });
  async function waitForUpload(ticketId, values) {
    if (values.filedinhkemkhac != undefined) {
      let resultOther = await Upload_Ticket_File_Modal(
        ticketId,
        values.filedinhkemkhac.file.originFileObj,
      );
      // console.log(resultOther)
    }
    let changeNewState = await deleteTicketAPI({
      ticket_id: ticketId,
      // newstatus: stateTo,
      log_destiny: "Test",
      logtype: 1,
      lydohuyyeucau: values.lydohuyyeucau,
    });
    // console.log(changeNewState)
    return "done";
  }
  const onFinish = (values) => {
    waitForUpload(ticketid, values).then((res) => {
      // console.log(res)
      setLoadingDelete(false);
      onCancel();
      fetchTicketDetail();
      // window.location.reload()
    });
  };
  const onOk = () => {
    setLoadingDelete(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingDelete(false);
  };
  const onCancelModal = () => {
    setselectedFileUploadList([]);
    form.setFieldsValue({
      filedinhkemkhac: null,
    });
    onCancel();
  };
  const uploadFileRequest = ({ file, onSuccess, name }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const handleChange = (info) => {
    let selectedFileList = [...info.fileList];
    setselectedFileUploadList(selectedFileList);
    if (selectedFileList.length === 0) {
      // console.log("remove");
      form.setFieldsValue({
        filedinhkemkhac: undefined,
      });
    }
  };
  return (
    <Modal
      title="Hủy yêu cầu"
      visible={visible}
      onOk={onOk}
      onCancel={onCancelModal}
    >
      <Spin spinning={loadingDelete}>
        <Form
          form={form}
          layout="vertical"
          name="userForm"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="lydohuyyeucau"
            label="Lý do hủy yêu cầu"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="filedinhkemkhac"
            label="Đính kèm file (không bắt buộc)"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Upload.Dragger
              fileList={selectedFileUploadList}
              onChange={handleChange}
              customRequest={uploadFileRequest}
            >
              <Button icon={<UploadOutlined />} htmlType="button">
                Nhấn để chọn file
              </Button>
            </Upload.Dragger>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};
const ModalFormAssign = ({
  visible,
  onCancel,
  ticketdata,
  stateTo,
  fetchTicketDetail,
}) => {
  const [form] = Form.useForm();
  const [typeAction, setTypeAction] = useState(null);
  const [listUserToDelete, setListUserToDelete] = useState([]);
  const [loadingAssign, setLoadingAssign] = useState(false);
  const [showModalManagerDone, setShowModalManagerDone] = useState(false);
  useResetFormOnCloseModal({
    form,
    visible,
  });
  async function waitForUpload(ticketId, values) {
    const actionType = values.type;
    switch (actionType) {
      case "add":
        await assignAddTicketAPI({
          ticket_id: ticketId,
          newstatus: stateTo,
          // log_destiny: "Phân công xử lí cho " + usernameXuLy,
          // logtype: 3,
          ls_user_assignment: values.list_nguoixuly,
          // lydothaydoinguoixuly:values.lydothaydoinguoixuly
        });
        break;
      case "delete":
        await assignDeleteTicketAPI({
          ticket_id: ticketId,
          newstatus: stateTo,
          // log_destiny: "Phân công xử lí cho " + usernameXuLy,
          // logtype: 3,
          ls_user_delete: values.list_delete_nguoixuly,
          lydoxoanguoixuly: values.lydoxoanguoixuly,
        });
        if (showModalManagerDone) {
          if (!values.user_xuly_new) {
            console.log("ok");
            // console.log(showModalManagerDone)
            await doneTicketAPI({
              ticket_id: ticketId,
              is_manage_done: true,
            });
          } else {
            await assignAddTicketAPI({
              ticket_id: ticketId,
              ls_user_assignment: values.user_xuly_new,
            });
          }
        }
        break;
      case "change":
        await assignChangeTicketAPI({
          ticket_id: ticketId,
          newstatus: stateTo,
          // log_destiny: "Phân công xử lí cho " + usernameXuLy,
          // logtype: 3,
          user_assignment_old: values.user_xuly_old,
          user_assignment: values.user_xuly_new,
          lydothaydoinguoixuly: values.lydothaydoinguoixuly,
        });
        break;
    }

    return "done";
  }

  const onFinish = (values) => {
    if (
      typeAction === "delete" &&
      values.list_delete_nguoixuly.length ==
        Object.entries(ticketdata.list_user_received).length
    ) {
      openNotificationWithIcon(
        "error",
        "Lỗi",
        "Yêu cầu này phải có ít nhất 1 người xử lý",
      );
      setLoadingAssign(false);
      return;
    }

    waitForUpload(ticketdata.id, values).then((res) => {
      setLoadingAssign(false);
      form.resetFields();
      setTypeAction(null);
      onCancel();
      fetchTicketDetail();
      // window.location.reload()
    });
  };
  const onFinishFailed = () => {
    setLoadingAssign(false);
  };
  const onOk = () => {
    setLoadingAssign(true);
    form.submit();
  };

  const onCancelModal = () => {
    setTypeAction(null);
    onCancel();
  };
  const changeAction = (value) => {
    form.resetFields();
    form.setFieldsValue({
      type: value.value,
    });
    setTypeAction(value.value);
    setShowModalManagerDone(false);
  };
  const CheckDeleteUserProcess = () => {
    // console.log(listUserToDelete.length)
    const maxSelect = ticketdata.list_user_received.filter(
      (item) => item.status === "Đang xử lý",
    ).length;
    // console.log(maxSelect)
    if (listUserToDelete.length === maxSelect) {
      setShowModalManagerDone(true);
    } else {
      setShowModalManagerDone(false);
    }
  };
  const onChangeDeleteUserProcess = (value) => {
    // console.log(value)
    setListUserToDelete(value);
    const maxSelect = ticketdata.list_user_received.filter(
      (item) => item.status === "Đang xử lý",
    ).length;
    if (value.length !== maxSelect) {
      setShowModalManagerDone(false);
    }
  };

  return (
    <Modal
      title="Xác nhận phân công yêu cầu"
      visible={visible}
      onOk={onOk}
      onCancel={onCancelModal}
    >
      <Spin spinning={loadingAssign}>
        <Form
          form={form}
          layout="vertical"
          name="userForm"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="type"
            label={"Chọn loại phân công"}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select onChange={(e, value) => changeAction(value)}>
              {ticketdata.list_user_not_received &&
              Object.entries(ticketdata.list_user_not_received).length > 0 ? (
                <Select.Option key={1} value={"add"}>
                  {"Thêm mới"}
                </Select.Option>
              ) : (
                ""
              )}
              <Select.Option
                key={2}
                value={"delete"}
                disabled={
                  ticketdata.list_user_received?.length <= 1 &&
                  !ticketdata.list_user_received?.some(
                    (item) => item.status === "Đang xử lý",
                  )
                }

                // disabled={
                //   ticketdata.list_user_received &&
                //   (Object.entries(ticketdata.list_user_received).length > 1) |
                //     (Object.entries(ticketdata.list_user_received).length ==
                //       1 &&
                //       Object.entries(
                //         ticketdata.list_user_received.filter(
                //           (item) => item.status === "Đang xử lý",
                //         ),
                //       ).length == 0)
                //     ? false
                //     : true
                // }
              >
                {"Xóa"}
              </Select.Option>
              <Select.Option
                key={3}
                value={"change"}
                disabled={
                  ticketdata.list_user_not_received &&
                  Object.entries(ticketdata.list_user_not_received).length >
                    0 &&
                  Object.entries(ticketdata.list_user_received).length > 0
                    ? false
                    : true
                }
              >
                {"Thay đổi"}
              </Select.Option>
            </Select>
          </Form.Item>
          {typeAction && typeAction === "add" ? (
            <Form.Item
              name="list_nguoixuly"
              label="Danh sách người xử lý"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select mode="multiple" showArrow={true}>
                {Object.entries(ticketdata.list_user_not_received).map(
                  ([key, value]) => (
                    <Select.Option key={value} value={value}>
                      {key}
                    </Select.Option>
                  ),
                )}
              </Select>
            </Form.Item>
          ) : null}

          {typeAction && typeAction === "delete" ? (
            <>
              <Form.Item
                name="list_delete_nguoixuly"
                label="Danh sách người đang xử lý"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  showArrow={true}
                  onBlur={() => CheckDeleteUserProcess()}
                  onChange={(value) => onChangeDeleteUserProcess(value)}
                >
                  {ticketdata.list_user_received
                    .filter((item) => item.status === "Đang xử lý")
                    .map((item) => (
                      <Select.Option key={item.user_id} value={item.user_id}>
                        {item.username}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="lydoxoanguoixuly"
                label="Lý do xóa người xử lý"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              {showModalManagerDone ? (
                <Form.Item
                  name="user_xuly_new"
                  label={
                    <span style={{ color: "#ff0000" }}>
                      Bạn vừa chọn xóa hết người đang xử lý, Vui lòng chọn người
                      nhận xử lý mới hoặc để trống để xác nhận Hoàn thành yêu
                      cầu này
                    </span>
                  }
                >
                  <Select mode="multiple" showArrow={true}>
                    {Object.entries(ticketdata.list_user_not_received).map(
                      ([key, value]) => (
                        <Select.Option key={value} value={value}>
                          {key}
                        </Select.Option>
                      ),
                    )}
                  </Select>
                </Form.Item>
              ) : null}
            </>
          ) : null}

          {typeAction && typeAction === "change" ? (
            <>
              <Form.Item
                name="user_xuly_old"
                label="Người đang xử lý"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select showArrow={true}>
                  {ticketdata.list_user_received
                    .filter((item) => item.status === "Đang xử lý")
                    .map((item, index) => (
                      <Select.Option key={index} value={item.user_id}>
                        {item.username}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="user_xuly_new"
                label="Người nhận xử lý mới"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select showArrow={true}>
                  {Object.entries(ticketdata.list_user_not_received).map(
                    ([key, value]) => (
                      <Select.Option key={value} value={value}>
                        {key}
                      </Select.Option>
                    ),
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="lydothaydoinguoixuly"
                label="Lý do thay đổi người xử lý"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </>
          ) : (
            ""
          )}
        </Form>
      </Spin>
    </Modal>
  );
};
const ModalFormReopen = ({
  visible,
  onCancel,
  ticketid,
  stateTo,
  fetchTicketDetail,
}) => {
  const [form] = Form.useForm();
  const [loadingReopen, setLoadingReopen] = useState(false);
  useResetFormOnCloseModal({
    form,
    visible,
  });
  async function waitForUpload(ticketId, values) {
    let changeNewState = await reprocessTicketAPI({
      ticket_id: ticketid,
      newstatus: stateTo,
      log_destiny: "Test",
      logtype: 1,
      lydoxulylai: values.lydoxulylai,
    });
    return "done";
  }
  const onFinish = (values) => {
    waitForUpload(ticketid, values).then((res) => {
      setLoadingReopen(false);
      onCancel();
      fetchTicketDetail();
    });
  };
  const onFinishFailed = () => {
    setLoadingReopen(false);
  };
  const onOk = () => {
    setLoadingReopen(true);
    form.submit();
  };
  const onCancelModal = () => {
    onCancel();
  };

  return (
    <Modal
      title="Xác nhận yêu cầu xử lý lại"
      visible={visible}
      onOk={onOk}
      onCancel={onCancelModal}
    >
      <Spin spinning={loadingReopen}>
        <Form
          form={form}
          layout="vertical"
          name="userForm"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="lydoxulylai"
            label="Lý do yêu cầu xử lý lại"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};
const ModalFormDone = ({
  visible,
  onCancel,
  ticketdata,
  stateTo,
  fetchTicketDetail,
}) => {
  const [form] = Form.useForm();
  // const [selectedFileUploadList, setSelectedFileUploadList] = useState([])
  const [loadingDone, setLoadingDone] = useState(false);
  const [visibleForward, setVisibleForward] = useState(false);
  const [userForward, setUserForward] = useState(null);
  const ticketid = ticketdata.id;
  const stateNow = ticketdata.ticket_status;
  useResetFormOnCloseModal({
    form,
    visible,
  });
  async function waitForUpload(ticketId, values) {
    let changeNewState = await doneTicketAPI({
      ticket_id: ticketid,
      newstatus: stateTo,
      log_destiny: "Test",
      logtype: 1,
      lydokhongxulylai: values.lydokhongxulylai,
    });
    return "done";
  }
  const onFinish = (values) => {
    waitForUpload(ticketid, values).then((res) => {
      // console.log(res)
      setLoadingDone(false);
      onCancel();
      fetchTicketDetail();
      // window.location.reload()
    });
  };
  const onFinishFailed = () => {
    setLoadingDone(false);
  };
  const onOk = () => {
    setLoadingDone(true);
    form.submit();
  };

  const onForwardTicket = async () => {
    setLoadingDone(true);
    await forwardTicketAPI({
      ticket_id: ticketid,
      user_forward: userForward,
    }).then((res) => {
      setLoadingDone(true);
      window.location.reload();
    });
  };

  const getFooter = () => {
    let footer = [
      <Button key="back" onClick={onCancel}>
        Thoát
      </Button>,
      <Button key="submit" type="primary" onClick={onOk}>
        Hoàn thành
      </Button>,
    ];
    if (
      ticketdata.list_user_not_received &&
      Object.entries(ticketdata.list_user_not_received).length > 0
    ) {
      footer.push([
        <Button
          key="link"
          type="primary"
          style={{ background: "#ff0000", borderColor: "#ff0000" }}
          // loading={loading}
          onClick={() => setVisibleForward(true)}
        >
          Chuyển tiếp
        </Button>,
      ]);
    }
    return footer;
  };
  return (
    <>
      <Modal
        title="Xác nhận hoàn thành yêu cầu "
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        footer={getFooter()}
      >
        <Spin spinning={loadingDone}>
          <Form
            form={form}
            layout="vertical"
            name="userForm"
            validateMessages={validateMessages}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            {stateNow === 6 ? (
              <Form.Item
                name="lydokhongxulylai"
                label="Lý do không xử lý lại"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            ) : (
              ""
            )}
          </Form>
        </Spin>
      </Modal>
      <Modal
        title={"Chuyển tiếp yêu cầu"}
        visible={visibleForward}
        onCancel={() => setVisibleForward(false)}
        onOk={onForwardTicket}
      >
        {ticketdata.list_user_not_received ? (
          <Select
            style={{ width: "100%" }}
            defaultValue="blank"
            onChange={(value) => setUserForward(value)}
          >
            <Select.Option key={"blank"} value={"blank"} disabled={true}>
              {"Chọn người xử lý"}
            </Select.Option>
            {Object.entries(ticketdata.list_user_not_received).map(
              ([key, value]) => (
                <Select.Option key={value} value={value}>
                  {key}
                </Select.Option>
              ),
            )}
          </Select>
        ) : null}
      </Modal>
    </>
  );
};

const FormLayout = (data) => {
  const currentUsername = useSelector((state) => state.user.user);
  const [form] = Form.useForm();
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [visibleFormAssignModal, setVisibleFormAssignModal] = useState(false);
  const [visibleFormReopenModal, setVisibleFormReopenModal] = useState(false);
  const [visibleFormDoneModal, setVisibleFormDoneModal] = useState(false);
  const [visibleFormDinhKemFileKhacModal, setvisibleFormDinhKemFileKhacModal] =
    useState(false);
  const [stateTo, setStateTo] = useState(false);
  const [isEditDueDate, setEditDueDate] = useState(false);
  const [newDueDate, setNewDueDate] = useState(null);
  const getModal = (ticketid, state_to, ticketCode, actionType) => {
    switch (actionType) {
      case "Phê duyệt":
        showConfirmAccept(
          data.setLoading,
          ticketid,
          state_to,
          ticketCode,
          actionType,
          data.fetchTicketDetail,
        );
        break;
      case "Hủy":
        showDeleteModal(ticketid, state_to, ticketCode, actionType);
        break;
      case "Tiếp nhận":
        showConfirmProcess(
          data.setLoading,
          ticketid,
          state_to,
          ticketCode,
          actionType,
          data.fetchTicketDetail,
        );
        break;
      case "Hoàn thành":
        showDoneModal(ticketid, state_to, ticketCode, actionType);
        break;
      case "Phân công":
        showAssignModal(ticketid, state_to, ticketCode, actionType);
        break;
      case "Đóng":
        showConfirmClose(
          data.setLoading,
          ticketid,
          state_to,
          ticketCode,
          actionType,
          data.fetchTicketDetail,
        );
        break;
      case "Xử lý lại":
        showReopenedModal(ticketid, state_to, ticketCode, actionType);
        break;
    }
  };

  const showDinhKemFileKhacModal = (
    ticketid,
    state_to,
    ticketCode,
    actionType,
  ) => {
    setvisibleFormDinhKemFileKhacModal(true);
  };
  const hideDinhKemFileKhacModal = () => {
    setvisibleFormDinhKemFileKhacModal(false);
  };
  const showDoneModal = (ticketid, state_to, ticketCode, actionType) => {
    setVisibleFormDoneModal(true);
    setStateTo(state_to);
  };
  const hideDoneModal = () => {
    setVisibleFormDoneModal(false);
  };
  const showDeleteModal = (ticketid, state_to, ticketCode, actionType) => {
    setVisibleDeleteModal(true);
    setStateTo(state_to);
  };
  const hideDeleteModal = () => {
    setVisibleDeleteModal(false);
  };
  const showAssignModal = (ticketid, state_to, ticketCode, actionType) => {
    setVisibleFormAssignModal(true);
    setStateTo(state_to);
  };
  const hideAssignModal = () => {
    setVisibleFormAssignModal(false);
  };
  const showReopenedModal = (ticketid, state_to, ticketCode, actionType) => {
    setVisibleFormReopenModal(true);
    setStateTo(state_to);
  };
  const hideReopenedModal = () => {
    setVisibleFormReopenModal(false);
  };
  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const ngaypheduyet = data.data.ticket_ngaypheduyet
    ? moment(data.data.ticket_ngaypheduyet).format("L")
    : null;
  const ngaytao = data.data.created
    ? moment(data.data.created).format("L")
    : null;
  let nguoixuly = data.data.list_user_received
    ? data.data.list_user_received.map((item, index) => {
        return index === 0 ? item.username : " " + item.username;
      })
    : null;
  const contentPopupNguoiXuLy = () => {
    if (data.data.list_user_received) {
      return (
        <List
          itemLayout="horizontal"
          dataSource={data.data.list_user_received}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={<a>{item.username}</a>}
                description={
                  <a
                    style={
                      item.status === "Hoàn thành"
                        ? { color: "#3a83ef" }
                        : { color: "#ff0000" }
                    }
                  >
                    {item.status}
                  </a>
                }
              />
            </List.Item>
          )}
        />
      );
    }
  };
  const editDueDate = (date, dateString) => {
    setNewDueDate(dateString);
  };
  const onSubmitNewDueDate = () => {
    if (!newDueDate) {
      openNotificationWithIcon(
        "error",
        "Lỗi",
        "Bạn chưa chọn thời hạn mong muốn",
      );
      return;
    }
    let newTicketData = {};
    newTicketData.ticket_id = data.data.id;
    newTicketData.duedate = newDueDate;
    authAxios(cookies.get("token"))
      .post(ticketUpdateDueDateURL, newTicketData)
      .then((res) => {
        // console.log(res)
        setEditDueDate(false);
        setNewDueDate(null);
        data.fetchTicketDetail();
      });
  };
  const onCalcelNewDueDate = () => {
    setEditDueDate(false);
  };
  useEffect(() => {
    var list_team_sd = [];

    if (data.data.list_name_team_use) {
      list_team_sd = data.data.list_name_team_use.map((item) => item.name);
      list_team_sd = list_team_sd.join(",");
    }

    form.setFieldsValue({
      bophanxuly: data.data.handling_group_name,
      vanphong: data.data.vanphong_name,
      bophansudung: data.data.bophansudung_name,
      other1_name: list_team_sd,
      nguoitao: data.data.username_create,
      nguoipheduyet: data.data.approve_user_name,
      name_cty: data.data.customer_name,
      loaiyeucau: data.data.ticket_type_name,
      ngaymongmuon: moment(data.data.duedate).format("DD/MM/YYYY"),
      ngaytao: ngaytao,
      ngaypheduyet: ngaypheduyet,
      nguoixuly: nguoixuly,
      tieudeyeucau: data.data.title,
      ghichu: data.data.description,
      trangthai: data.data.ticket_status_name,
      lydohuyyeucau: data.data.lydohuyyeucau,
      lydoxulylai: data.data.lydoxulylai,
      lydokhongxulylai: data.data.lydokhongxulylai,
      lydothaydoinguoixuly: data.data.lydothaydoinguoixuly,
    });
  });
  return (
    <>
      <Form
        // {...layout}
        layout={"vertical"}
        labelCol={{ span: 22, offset: 1 }}
        wrapperCol={{ span: 22, offset: 1 }}
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        validateMessages={validateMessages}
        labelAlign={"left"}
      >
        <Row>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Form.Item
              label="Bộ phận xử lý"
              name="bophanxuly"
              className={"ticket-detail-form-item"}
            >
              <Input readOnly={true} />
            </Form.Item>
            <Form.Item
              label="Loại yêu cầu"
              name="loaiyeucau"
              className={"ticket-detail-form-item"}
            >
              <Input readOnly={true} />
            </Form.Item>
            {data.data.username_create !== currentUsername ? (
              <Form.Item
                label="Người tạo"
                name="nguoitao"
                className={"ticket-detail-form-item"}
              >
                <Input readOnly={true} />
              </Form.Item>
            ) : (
              ""
            )}
            <Form.Item
              label="Người phê duyệt"
              name="nguoipheduyet"
              className={"ticket-detail-form-item"}
            >
              <Input readOnly={true} />
            </Form.Item>
            <Form.Item
              label="Công ty"
              name="name_cty"
              className={"ticket-detail-form-item"}
            >
              <Input readOnly={true} />
            </Form.Item>
            <Row>
              <Col span={11} style={{ marginLeft: "2.166667%" }}>
                <Form.Item
                  label="Phòng/Department"
                  name="bophansudung"
                  className={"ticket-detail-form-item"}
                >
                  <Input readOnly={true} />
                </Form.Item>
              </Col>
              <Col span={11} offset={1}>
                <Form.Item
                  label="Team sử dụng"
                  name="other1_name"
                  className={"ticket-detail-form-item"}
                >
                  <Input readOnly={true} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label="Văn phòng"
              name="vanphong"
              className={"ticket-detail-form-item"}
            >
              <Input readOnly={true} />
            </Form.Item>
            <Form.Item
              label="Ngày tạo"
              name="ngaytao"
              className={"ticket-detail-form-item"}
            >
              <Input readOnly={true} />
            </Form.Item>
            {!isEditDueDate ? (
              <Form.Item
                label="Thời hạn mong muốn"
                name="ngaymongmuon"
                className={"ticket-detail-form-item"}
              >
                <Input
                  readOnly={true}
                  addonAfter={
                    [1, 2, 3, 6].includes(data.data.ticket_status) ? (
                      <a onClick={() => setEditDueDate(true)}>
                        <EditTwoTone />
                      </a>
                    ) : null
                  }
                />
              </Form.Item>
            ) : (
              <Form.Item
                label="Thời hạn mong muốn"
                name="duedate"
                initialValue={moment(new Date(data.data.duedate), customFormat)}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  defaultValue={moment(
                    new Date(data.data.duedate),
                    "DD/MM/YYYY",
                  )}
                  onChange={editDueDate}
                  disabledDate={(current) =>
                    disabledDate(current, new Date(data.data.duedate))
                  }
                  format={customFormat}
                  allowClear={false}
                />
                <span style={{ position: "absolute", right: 0 }}>
                  <Button onClick={onSubmitNewDueDate}>
                    <SaveTwoTone twoToneColor={"#0066ff"} />
                  </Button>
                  <Button onClick={onCalcelNewDueDate}>
                    <CloseCircleTwoTone twoToneColor={"#ff0000"} />
                  </Button>
                </span>
              </Form.Item>
            )}
            {ngaypheduyet ? (
              <Form.Item
                label="Ngày phê duyệt"
                name="ngaypheduyet"
                className={"ticket-detail-form-item"}
              >
                <Input readOnly={true} />
              </Form.Item>
            ) : (
              ""
            )}
            {data.data.list_user_received &&
            Object.entries(data.data.list_user_received).length > 0 ? (
              <Form.Item label="Người xử lý" name="nguoixuly">
                <Input
                  readOnly={true}
                  value={nguoixuly}
                  addonAfter={
                    <Popover
                      content={contentPopupNguoiXuLy}
                      title="Tình trạng xử lý"
                    >
                      <EyeTwoTone />
                    </Popover>
                  }
                />
              </Form.Item>
            ) : (
              ""
            )}
          </Col>
          <Col xs={24} sm={24} md={24} lg={16} xl={16}>
            <Row>
              <Col xs={6} sm={24} md={6} lg={6} xl={6}>
                <Form.Item
                  wrapperCol={{ ...layout.wrapperCol, offset: 4 }}
                  labelCol={{ ...layout.labelCol, offset: 4 }}
                  label="Trạng thái"
                  name="trangthai"
                >
                  <Button
                    style={{
                      backgroundColor: data.data.color,
                      color: data.data.textcolor,
                    }}
                  >
                    {data.data.ticket_status_name}
                  </Button>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={18} xl={18}>
                <Row className={"abc"}>
                  {data.lsBtn.map((item, i) => (
                    <Button
                      type="primary"
                      key={i}
                      style={{
                        marginTop: 32,
                        marginRight: 10,
                        backgroundColor: item.color,
                        border: "none",
                      }}
                      onClick={() =>
                        getModal(
                          data.ticketid,
                          item.state_to,
                          item.ticketCode,
                          item.button,
                        )
                      }
                    >
                      {item.button}
                    </Button>
                  ))}
                </Row>
              </Col>
            </Row>
            <Form.Item
              label="Tiêu đề yêu cầu"
              name="tieudeyeucau"
              className={"ticket-detail-form-item"}
            >
              <TextArea readOnly={true} />
            </Form.Item>
            {data.data.description ? (
              <Form.Item
                label="Ghi chú"
                name="ghichu"
                className={"ticket-detail-form-item"}
              >
                <TextArea readOnly={true} rows={6} />
              </Form.Item>
            ) : null}

            {data.data.attachment_files &&
            Object.entries(data.data.attachment_files).length > 0 ? (
              <Form.Item
                label="File đính kèm"
                className={"ticket-detail-form-item"}
              >
                {Object.entries(data.data.attachment_files).map(
                  ([key, value]) => (
                    <p key={key}>
                      <a href={value} target="_blank">
                        {key}
                      </a>
                    </p>
                  ),
                )}
              </Form.Item>
            ) : null}
          </Col>
        </Row>
      </Form>
      <br />
      <ModalDinhKemFileKhac
        visible={visibleFormDinhKemFileKhacModal}
        onCancel={hideDinhKemFileKhacModal}
        ticketid={data.data.id}
        fetchTicketDetail={() => data.fetchTicketDetail()}
      />
      <ModalFormDelete
        visible={visibleDeleteModal}
        onCancel={hideDeleteModal}
        ticketid={data.data.id}
        ticketCode={data.data.ticket_code}
        stateTo={stateTo}
        fetchTicketDetail={() => data.fetchTicketDetail()}
      />
      <ModalFormAssign
        visible={visibleFormAssignModal}
        onCancel={hideAssignModal}
        ticketdata={data.data}
        stateTo={stateTo}
        fetchTicketDetail={() => data.fetchTicketDetail()}
      />
      <ModalFormReopen
        visible={visibleFormReopenModal}
        onCancel={hideReopenedModal}
        ticketid={data.data.id}
        ticketCode={data.data.ticket_code}
        stateTo={stateTo}
        fetchTicketDetail={() => data.fetchTicketDetail()}
      />
      <ModalFormDone
        visible={visibleFormDoneModal}
        onCancel={hideDoneModal}
        ticketdata={data.data}
        stateTo={stateTo}
        fetchTicketDetail={() => data.fetchTicketDetail()}
      />
    </>
  );
};

class TicketDetail extends React.Component {
  state = {
    loading: false,
    error: null,
    formVisible: false,
    activeKey: "1",
    data: {},
    formData: {},
    list_bophanxuly: [],
    bophanxuly: "",
    list_fileattach: [],
    listLichsuthaydoi: [],
    listaction: [],
    lsBtn: [],
    reload: false,
    editingSectionIndex: -1,
    newEditData: {},
    loadingSave: false,
    selectedFileList: [],
    loadingUpload: false,
  };
  refreshPage = () => {
    this.setState({ reload: true }, () => this.setState({ reload: false }));
  };
  componentDidMount() {
    this.handleFetchItem();
  }

  setLoading = (value) => {
    this.setState({ loading: value });
  };

  fetchListAction = (ticketid) => {
    authAxios(cookies.get("token"))
      .post(ListAction, { ticketid: ticketid })
      .then((res) => {
        const results = res.data.dictbutton;
        var datares = Object.entries(results).map(([key, value]) => ({
          button: key,
          color: value,
        }));
        this.setState({ lsBtn: datares });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  handleLichsuthaydoi = () => {
    const {
      match: { params },
    } = this.props;
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(listLichsuthaydoi(params.ticketID))
      .then((res) => {
        this.setState({ listLichsuthaydoi: res.data, loading: false });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };
  handleFetchItem = () => {
    const {
      match: { params },
    } = this.props;
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(ticketDetailURL(params.ticketID))
      .then((res) => {
        const results = res.data.list_button;
        var datares = Object.entries(results).map(([key, value]) => ({
          button: key,
          color: value,
          // 'state_to': value[1],
          ticketCode: res.data.ticket_code,
        }));
        this.setState({ data: res.data, loading: false, lsBtn: datares });
        this.props.ticketData(res.data);
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.data.message === "You do not have access") {
          this.props.history.push("/notpermission");
          return false;
        }
      });
  };
  handleChangeTab = (activeKey) => {
    this.setState({ activeKey });
    if (activeKey === "2") {
      this.handleLichsuthaydoi();
    }
  };

  getResultData = (value, data) => {
    // console.log('callback')
    let obj = {};
    let children_obj = {};
    children_obj.data = value;
    children_obj.header = data.data_item.dataform.header;
    obj.dataform = children_obj;
    this.setState({ newEditData: obj });
    // console.log('end-debug-callback')
  };
  onSubmitAllRow = () => {
    let elements = document.getElementsByClassName("submitAllForm");
    if (elements && elements.length > 0) {
      for (const btn of elements) {
        btn.click();
      }
    }
  };

  // CheckSubmit = async (ticketID, newEditData) => {
  //   let CheckForm = await this.onSubmitAllRow();
  //   await this.toggleSave(ticketID, newEditData);
  // };

  CheckSubmit = async (ticketID, newEditData, sectionIndex) => {
    await this.onSubmitAllRow();

    // Filter data for the specific section
    const section = this.state.data.data_item.dataform.header[sectionIndex];
    const sectionKeys = section.children.map((child) => child.dataIndex);
    sectionKeys.push("key"); // Keep row identifier

    const filteredData = newEditData.dataform.data
      .map((row) => {
        const newRow = {};
        sectionKeys.forEach((key) => {
          if (row.hasOwnProperty(key)) {
            newRow[key] = row[key];
          }
        });
        return newRow;
      })
      .sort((a, b) => a.key - b.key);

    const filteredPayload = {
      dataform: {
        data: filteredData,
        header: [section],
      },
    };

    await this.toggleSave(ticketID, filteredPayload);
  };

  toggleSave = async (id, value) => {
    await timeout(500);
    let elementsErr = document.getElementsByClassName(
      "ant-form-item-explain-error",
    );
    if (elementsErr.length !== 0) {
      openNotificationWithIcon(
        "error",
        "Lỗi",
        "Vui lòng điền đủ thông tin vào các trường bắt buộc",
      );
      return;
    }

    if (Object.keys(value).length !== 0) {
      this.setState({ loadingSave: true });
      authAxios(cookies.get("token"))
        .post(ticketUpdateFormData, { ticket_id: id, formDataTicket: value })
        .then((res) => {
          // console.log(res)
          this.handleFetchItem();
          this.setState({ loadingSave: false, editingSectionIndex: -1 });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loadingSave: false, editingSectionIndex: -1 });
        });
    } else {
      this.setState({ loadingSave: false, editingSectionIndex: -1 });
    }
  };
  toggleEditing = () => {
    // Deprecated for per-section editing
  };
  cloneTicketFC = () => {
    const { data } = this.state;
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(listLoaiyeucauAll, {
        params: { handling_group: data.handling_group, page_size: 1000 },
      })
      .then((res) => {
        this.setState({ loading: false });
        const list = (res.data.results || []).filter(
          (item) => item.is_active === true,
        );
        if (!list.some((item) => item.id === data.ticket_type)) {
          Modal.warning({
            title: "Cảnh báo",
            content:
              "Loại yêu cầu này hiện không còn tồn tại hoặc đã bị vô hiệu hóa. Bạn không thể sao chép yêu cầu này.",
          });
          return;
        }
        this.props.cloneTicket(true);
        this.props.history.push("/create_ticket");
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.log(err);
        this.props.cloneTicket(true);
        this.props.history.push("/create_ticket");
      });
  };
  handleUpload = () => {
    const { ticketID } = this.props.match.params;
    const { selectedFileList } = this.state;
    if (selectedFileList.length === 0) {
      openNotificationWithIcon("error", "Lỗi", "Vui lòng chọn file đính kèm");
      return;
    }
    this.setState({ loadingUpload: true });
    Upload_Ticket_File(ticketID, selectedFileList)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Thành công",
          "Đính kèm file thành công",
        );
        this.setState({ selectedFileList: [], loadingUpload: false });
        this.handleFetchItem();
      })
      .catch((err) => {
        this.setState({ loadingUpload: false });
        openNotificationWithIcon("error", "Lỗi", "Đính kèm file thất bại");
      });
  };
  handleChangeFile = (info) => {
    this.setState({ selectedFileList: info.fileList });
  };
  renderSectionTitle = (item, index) => {
    const { editingSectionIndex, loadingSave, data } = this.state;
    const { user, isProcess } = this.props;
    const isEditing = editingSectionIndex === index;
    const ticketID = this.props.match.params.ticketID;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ color: item.colortitle }}>{item.title}</div>
        <div>
          {!isEditing ? (
            <>
              {["2", "3", "6"].includes(data.ticket_status.toString()) &&
              (isProcess || data.username_create === user) ? (
                <Button
                  type={"primary"}
                  size="small"
                  onClick={() => this.setState({ editingSectionIndex: index })}
                >
                  Chỉnh sửa
                </Button>
              ) : null}
            </>
          ) : (
            <div style={{ display: "flex", gap: "8px" }}>
              <Button
                type={"primary"}
                size="small"
                onClick={() =>
                  this.CheckSubmit(ticketID, this.state.newEditData, index)
                }
              >
                <Spin spinning={loadingSave} size="small">
                  Lưu
                </Spin>
              </Button>
              <Button
                size="small"
                onClick={() => this.setState({ editingSectionIndex: -1 })}
              >
                Hủy
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  };
  render() {
    const { user, userPermission, isProcess } = this.props;
    const { ticketID } = this.props.match.params;
    const {
      loading,
      activeKey,
      data,
      listLichsuthaydoi,
      isEditing,
      newEditData,
      loadingSave,
    } = this.state;

    const OperationsSlot = {
      right: (
        <>
          <h1 style={{ color: "#ff0000" }}>
            {data.ticket_code}&nbsp;&nbsp;&nbsp;
            <Button type={"primary"} onClick={() => this.cloneTicketFC()}>
              Sao chép
            </Button>
          </h1>
        </>
      ),
    };
    return (
      <>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Tabs
              defaultActiveKey={activeKey}
              onChange={this.handleChangeTab}
              tabBarExtraContent={OperationsSlot}
            >
              <TabPane tab="Nội dung yêu cầu" key="1">
                <Spin spinning={loading}>
                  <FormLayout
                    ticketid={ticketID}
                    {...this.state}
                    fetchTicketDetail={() => this.handleFetchItem()}
                    setLoading={this.setLoading}
                  />
                  <Row style={{ padding: "15px" }}>
                    <Col span={24}>
                      <AsyncMention
                        ticketid={ticketID}
                        fetchTicketDetail={() => this.handleFetchItem()}
                      />
                      {data.comments ? (
                        <ListComment
                          CommentData={data.comments}
                          fetchTicketDetail={() => this.handleFetchItem()}
                        />
                      ) : null}
                    </Col>
                  </Row>
                </Spin>
              </TabPane>
              {data.data_item ? (
                <TabPane tab={"Chi tiết yêu cầu"} key="3">
                  <EditableTable
                    dataSource={data.data_item.dataform.data}
                    columns={data.data_item.dataform.header}
                    callBackfunction={(value) =>
                      this.getResultData(value, data)
                    }
                    editingIndex={this.state.editingSectionIndex}
                    renderSectionTitle={this.renderSectionTitle}
                    isDetail={true}
                    is_username_create={data.username_create === user}
                    is_roleUser={isProcess}
                  />

                  <Card
                    title={
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        <PaperClipOutlined /> File đính kèm & Tải lên
                      </span>
                    }
                    size="small"
                    style={{
                      marginTop: "20px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                      border: "1px solid #f0f0f0",
                    }}
                  >
                    {["2", "3", "6"].includes(
                      data.ticket_status.toString(),
                    ) && (
                      <div
                        style={{
                          background: "#fafafa",
                          padding: "16px",
                          borderRadius: "8px",
                          marginBottom: "16px",
                          border: "1px dashed #d9d9d9",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            flexWrap: "wrap",
                          }}
                        >
                          <Upload
                            multiple
                            fileList={this.state.selectedFileList}
                            onChange={this.handleChangeFile}
                            beforeUpload={() => false}
                          >
                            <Button icon={<UploadOutlined />}>
                              Chọn file đính kèm
                            </Button>
                          </Upload>
                          {this.state.selectedFileList.length > 0 && (
                            <Button
                              type="primary"
                              onClick={this.handleUpload}
                              loading={this.state.loadingUpload}
                            >
                              Bắt đầu tải lên
                            </Button>
                          )}
                        </div>
                        <div
                          style={{
                            marginTop: "8px",
                            fontSize: "12px",
                            color: "#8c8c8c",
                          }}
                        >
                          Hỗ trợ tải lên nhiều định dạng file cùng lúc.
                        </div>
                      </div>
                    )}

                    {data.attachment_files &&
                    Object.entries(data.attachment_files).length > 0 ? (
                      <List
                        size="small"
                        header={
                          <div style={{ fontWeight: "600", color: "#595959" }}>
                            Danh sách file đã đính kèm:
                          </div>
                        }
                        dataSource={Object.entries(data.attachment_files)}
                        renderItem={([key, value]) => (
                          <List.Item>
                            <List.Item.Meta
                              avatar={
                                <PaperClipOutlined
                                  style={{ color: "#1890ff" }}
                                />
                              }
                              title={
                                <a
                                  href={value}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#262626" }}
                                >
                                  {key}
                                </a>
                              }
                            />
                          </List.Item>
                        )}
                      />
                    ) : (
                      !this.state.selectedFileList.length && (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            color: "#bfbfbf",
                          }}
                        >
                          Chưa có file nào được đính kèm
                        </div>
                      )
                    )}
                  </Card>
                </TabPane>
              ) : null}
              <TabPane tab="Lịch sử thay đổi" key="2">
                {listLichsuthaydoi.map((item, index) => (
                  <Card loading={loading} key={index}>
                    <div>
                      <h4>
                        <a>{item.username}</a>
                        <span> - cập nhật lúc</span>{" "}
                        {moment(item.created).format("DD/MM/YYYY HH:mm:ss")}
                      </h4>
                      {(() => {
                        return (
                          <>
                            <Row>
                              <Col sm={10}>
                                <span>{item.system_log}</span>
                              </Col>
                              <Col sm={14}>
                                <span>
                                  {item.user_log} {item.comment_content}
                                </span>
                              </Col>
                            </Row>
                          </>
                        );
                      })()}
                    </div>
                  </Card>
                ))}
              </TabPane>
              {data.ticket_type_att_file && (
                <TabPane tab="Tài liệu hướng dẫn quy trình" key="5">
                  <PDFViewer
                    urlPDF={`${localhost}/media/${
                      data.ticket_type_att_file.toString().split("/media/")[1]
                    }`}
                  />
                </TabPane>
              )}
            </Tabs>
          </Col>
        </Row>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addUser: (user) => dispatch(getUser(user)),
    ticketData: (data) => dispatch(ticketData(data)),
    cloneTicket: (bool) => dispatch(cloneTicket(bool)),
  };
};

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    userPermission: state.user.userPermission,
    isProcess: state.user.isProcess,
    ticketData: state.ticketData,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketDetail),
);
